module.exports = __webpack_public_path__ + "static/media/relationship_sibling.c8d1c2a6.svg";